import type { SupportedLocale } from "@playbrain/content-types"

/**
 * The microsite lives under /[locale]/playdata rather than on its own domain,
 * so every internal link has to carry the locale segment. Centralising the
 * paths keeps the header, footer and in-page CTAs from drifting apart.
 *
 * Mirrors the live header: About, a Services dropdown holding the two report
 * pages, News, Contact, then the locale flag.
 */
export const playdataNavItems = [
  { key: "about", to: "/$locale/playdata/about" },
  { key: "news", to: "/$locale/playdata/news" },
  { key: "contact", to: "/$locale/contact" },
] as const

export const playdataServiceItems = [
  { key: "eventReport", to: "/$locale/playdata/event-report" },
  { key: "streamerReport", to: "/$locale/playdata/streamer-report" },
] as const

export const playdataFooterItems = [
  { key: "terms", to: "/$locale/playdata/terms" },
  { key: "privacy", to: "/$locale/playdata/privacy" },
] as const

export function playdataAlternateLocale(locale: SupportedLocale): SupportedLocale {
  return locale === "ja" ? "en" : "ja"
}
